<div class="d-flex">
  <ul class="align-self-center m-0 p-0">
    <li class="mx-2 my-1" *ngFor="let link of links">
      <a *ngIf="link.isExternal" [href]="link.uri" target="_blank">{{ link.name }}</a>
      <a *ngIf="!link.isExternal" href="" (click)="$event.preventDefault(); linkSelected.emit(link.uri)">{{ link.name }}</a>
    </li>
  </ul>
</div>
